import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
// import AppNavbar from "../../Navbar/AppNavbar";
import AppLayout from "../../Navbar/AppLayout";
import Footer from "../../Navbar/Footer";
import saveImg from "../../../assets/images/searchContact/saveImgWhite.svg";
import "../../../assets/css/search.scss";
import EditSavedSearchModal from "./EditSavedSearchModal";
import DeleteSavedSearchConfirmModal from "./DeleteSavedSearchConfirmModal";
import { useDispatch, useSelector } from "react-redux";
import { loadSavedSearches, updateSavedSearchData } from "../../redux/action";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";

const SavedSearches = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const { savedSearchData } = useSelector((state) => state.data);

    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedIndexToDelete, setSelectedIndexToDelete] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedSearch, setSelectedSearch] = useState(null);

    const handleMenuToggle = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
    };

    const handleOpenEdit = (item) => {
        setSelectedSearch(item);
        setShowEditModal(true);
        setOpenMenuIndex(null);
    };

    const handleDeleteClick = (item) => {
        setSelectedSearch(item);
        setShowDeleteModal(true);
    };

    const fetchSavedSearches = () => {
        dispatch(loadSavedSearches(signInID, sbnID, setLoading));
    }

    useEffect(() => {
        fetchSavedSearches()
    }, [dispatch, signInID, sbnID]);


    const handleView = (item) => {
        const secret = "123456"; // Should be stored securely
        const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(item.search_data), secret).toString();
        navigate(`/contact-filter?data=${encodeURIComponent(ciphertext)}`);
    }

    return (
        <div className="page-layout">
            {/* <AppNavbar /> */}
            <AppLayout>
            <div className="page-content">
                <div className="saved-search-container">
                    <div className="saved-search-header-container">
                        <div className="saved-search-header-div">
                            <p>Saved</p>
                            <div className="saved-search-img-div">
                                <h5>Searches</h5>
                                <img src={saveImg} alt="Save" />
                            </div>
                        </div>
                    </div>
                    <div className="saved-searches-body">
                        <Row className="m-0 saved-searches-card-row">
                            {savedSearchData.length > 0 ? (
                                savedSearchData.map((item, index) => (
                                    <Col md={3} sm={6} xs={12} className="saved-searches-card-col mb-3" key={index}>
                                        <Card className="shadow-sm h-100 position-relative">
                                            <Card.Body>
                                                <div className="d-flex justify-content-between align-items-start mb-2 position-relative">
                                                    <Card.Title className="mb-0 fs-6 fw-semibold">{item.saved_search_name}</Card.Title>
                                                    <i
                                                        className="fa-solid fa-ellipsis-vertical"
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => handleMenuToggle(index)}
                                                    ></i>

                                                    {openMenuIndex === index && (
                                                        <div className="dropdown-card-options">
                                                            <div className="dropdown-item" onClick={() => handleView(item)}>
                                                                <p><i className="fa-solid fa-eye"></i><span>View</span></p>
                                                            </div>
                                                            <div className="dropdown-item" onClick={() => handleOpenEdit(item)}>
                                                                <p><i className="fa-solid fa-pen-to-square"></i><span>Edit</span></p>
                                                            </div>
                                                            <div className="dropdown-item" onClick={() => handleDeleteClick(item)}>
                                                                <p><i className="fa-solid fa-trash"></i><span>Delete</span></p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <Card.Text className="card-date-time">
                                                    <p>Time <span>: {new Date(item.date_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span></p>
                                                    <p>Date <span>: {new Date(item.date_time).toLocaleDateString()}</span></p>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <p>No saved searches available</p>
                            )}
                        </Row>
                    </div>
                </div>

                {/* Modal Component (UI only) */}
                <EditSavedSearchModal
                    show={showEditModal}
                    onHide={() => setShowEditModal(false)}
                    updateSavedSearchData={updateSavedSearchData}
                    selectedSearch={selectedSearch}
                    fetchSavedSearches={fetchSavedSearches}
                />
                <DeleteSavedSearchConfirmModal
                    show={showDeleteModal}
                    onHide={() => setShowDeleteModal(false)}
                    selectedSearch={selectedSearch}
                    fetchSavedSearches={fetchSavedSearches}
                />
            </div>
            </AppLayout>
            <Footer />
        </div>
    );
};

export default SavedSearches;
